import { FlightState } from "@/lib/redux/features/flight/type"
import { FLIGHT_SORT_TIER_COUNT, getFlightSortTier } from "./getFlightSortTier"

/**
 * Mode "gợi ý" (mặc định, chưa bấm nút sort nào): gom kết quả theo TIER ưu tiên hãng
 * (xem getFlightSortTier), GIỮ NGUYÊN thứ tự đã sort (giá thấp→cao) bên trong từng tier.
 * Khi user bấm 1 nút sort tường minh thì dùng commonSort (hành vi cũ) thay cho hàm này.
 */
export const tierPrioritySort = (state: FlightState, flightIds: any[]) => {
  const buckets: string[][] = Array.from({ length: FLIGHT_SORT_TIER_COUNT }, () => [])

  for (const flightId of flightIds) {
    const tier = getFlightSortTier(state, flightId)
    buckets[tier].push(flightId)
  }

  return buckets.flat()
}
